import { render, staticRenderFns } from "./MaterialSelector.vue?vue&type=template&id=43019d3b&scoped=true&"
import script from "./MaterialSelector.vue?vue&type=script&lang=js&"
export * from "./MaterialSelector.vue?vue&type=script&lang=js&"
import style0 from "./MaterialSelector.vue?vue&type=style&index=0&id=43019d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43019d3b",
  null
  
)

export default component.exports